import { CONFIG } from 'src/config-global';
import ServiceRequest from '../ServiceRequest';

export const getModuleListData = async (application_name: string, role: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/${application_name}/${role}/list/all`;
  return ServiceRequest.get(url);
};

export const getPageForm = async (module_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/${module_name}/get-page-form`;
  return ServiceRequest.get(url);
};

export const getUserPageForm = async (module_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/${module_name}/get-page-form`;
  return ServiceRequest.get(url);
};

export const getDefaultValues = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/auth/${module_name}/get-default-values`;
  return ServiceRequest.post(url, { payload: values });
};

export const getUserDefaultValues = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/get-default-values`;
  return ServiceRequest.post(url, { payload: values });
};

export const getAdminDefaultValues = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/get-default-values`;
  return ServiceRequest.post(url, { payload: values });
};

export const getAdminPageForm = async (module_name: string): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/get-page-form`;
  return ServiceRequest.get(url);
};

export const getAdminSubModulePageForm = async (
  module_name: string,
  submodule_name: string
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/submodule/${submodule_name}/get-submodule-page-form`;
  return ServiceRequest.get(url);
};

export const getUserSubModulePageForm = async (
  module_name: string,
  submodule_name: string
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/${module_name}/submodule/${submodule_name}/get-submodule-page-form`;
  return ServiceRequest.get(url);
};

export const getAdminModulePageData = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/get-page-data`;
  return ServiceRequest.post(url, { payload: values });
};

export const getUserModulePageData = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/get-page-data`;
  return ServiceRequest.post(url, { payload: values });
};

export const deleteAdminModuleRecord = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/execute-delete`;
  return ServiceRequest.post(url, { payload: values });
};

export const getAdminSubModulePageData = async (
  module_name: string,
  submodule_name: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/submodule/${submodule_name}/get-page-data`;
  return ServiceRequest.post(url, { payload: values });
};

export const executeUserActions = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/execute-action`;
  return ServiceRequest.post(url, { payload: values });
};
export const executeAuthProcedure = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/execute-procedure`;
  return ServiceRequest.post(url, { payload: values });
};

export const executeAdminActions = async (
  module_name: string,
  submodule_name: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/admin/${module_name}/submodule/${submodule_name}/execute-action`;
  return ServiceRequest.post(url, { payload: values });
};

export const executeStoredProcedure = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/execute-procedure`;
  return ServiceRequest.post(url, { payload: values });
};

export const sendEmail = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/${module_name}/send-email`;
  return ServiceRequest.post(url, { payload: values });
};

export const signOutUser = async (data: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/logout`;
  return ServiceRequest.post(url, { payload: data });
};

export const getToolbarOptions = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/admin/getToolbarOptions`;
  return ServiceRequest.post(url, { payload: values });
};

export const getBannerDetails = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/get_banner_values`;
  return ServiceRequest.post(url, { payload: values });
};
export const getPersonalInfo = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/get_profile_info`;
  return ServiceRequest.post(url, { payload: values });
};
export const editPersonalInfo = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/edit_profile_info`;
  return ServiceRequest.post(url, { payload: values });
};
export const editBasicInfo = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/edit_basic_info`;
  return ServiceRequest.post(url, { payload: values });
};
export const resetSecurityQuestion = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/change_security_question`;
  return ServiceRequest.post(url, { payload: values });
};
export const updatePassword = async (values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/auth/change_password`;
  return ServiceRequest.post(url, { payload: values });
};
export const getAppConfig = async (): Promise<any> => {
  const url = `${CONFIG.baseUrl}/user/get_application_configuration`;
  return ServiceRequest.get(url);
};

export const getDndDraggableList = async (module_name: string, values: any): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/user/${module_name}/get-dnd-draggable-list`;
  return ServiceRequest.post(url, { payload: values });
};

export const chatDataService = async (
  role: string,
  module_name: string,
  conversation_type: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/${role}/${module_name}/${conversation_type}/messages`;
  return ServiceRequest.post(url, { payload: values });
};

export const notificationDataService = async (
  role: string,
  module_name: string,
  notification_type: string,
  values: any
): Promise<any> => {
  const url = `${CONFIG.baseUrl}/data/${role}/${module_name}/${notification_type}/notifications`;
  return ServiceRequest.post(url, { payload: values });
};
